import { AppSettingsStateViewModel } from 'alg-ecom-frontend-core';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Dispatch } from 'redux';
import { FullPageLoader } from '../../components/loader';
import { RouteKeys } from './route-keys';
import UnAuthenticateRoute from './UnAuthenticatedRoute';

const NotFound = lazy(() => import('../notfound'));

const SubRoutes = lazy(() => import('./SubRoutes'));

const PaymentLink = lazy(() => import('../payment/PaymentLink'));
const PaymentLinkSuccess = lazy(() => import('../payment/PaymentLinkSuccess'));
const DiscountApproval = lazy(() => import('../discount-approval/index'));

const CustomerPaymentLink = lazy(
  () => import('../payment/PaymentLinkCustomer')
);

const CustomerPaymentLinkSuccess = lazy(
  () => import('../payment/PaymentLinkSuccessCustomer')
);
const ApprovalStatus = lazy(
  () => import('../discount-approval/ApprovalStatus')
);

const ApproveConfigurationRefund = lazy(
  () => import('../approve-configuration-refund/index')
);
const ApproveConfigurationRefundStatus = lazy(
  () => import('../approve-configuration-refund/ApprovalStatus')
);

const ApproveCustomerRefund = lazy(
  () => import('../approve-customer-refund/index')
);
const ApproveCustomerRefundStatus = lazy(
  () => import('../approve-customer-refund/ApprovalStatus')
);

const ApproveInvoiceCancel = lazy(
  () => import('../approve-invoice-cancel/index')
);
const ApproveInvoiceCancelStatus = lazy(
  () => import('../approve-invoice-cancel/ApprovalStatus')
);

const ApproveOrderCancel = lazy(() => import('../approve-order-cancel/index'));
const ApproveOrderCancelStatus = lazy(
  () => import('../approve-order-cancel/ApprovalStatus')
);

const ApproveVin = lazy(() => import('../approve-vin/index'));
const ApproveVinStatus = lazy(() => import('../approve-vin/ApprovalStatus'));

const ApproveTechConsultation = lazy(
  () => import('../approve-tech-consultation/index')
);
const ApproveTechConsultationStatus = lazy(
  () => import('../approve-tech-consultation/ApprovalStatus')
);

const ApproveVinExtension = lazy(
  () => import('../approve-vin-extension/index')
);
const ApproveVinExtensionStatus = lazy(
  () => import('../approve-vin-extension/ApprovalStatus')
);

const SpecialApproveBooking = lazy(
  () => import('../special-approve-booking/index')
);
const SpecialApproveBookingStatus = lazy(
  () => import('../special-approve-booking/ApprovalStatus')
);

const LostLead = lazy(() => import('../lost-lead/index'));
const LostLeadStatus = lazy(() => import('../lost-lead/ApprovalStatus'));

const VerifyEmail = lazy(() => import('../verify-email/VerifyEmail'));

interface CustomProps {
  appSettingsState: AppSettingsStateViewModel;
}
const Routes: React.FunctionComponent<CustomProps> = (props) => {
  return (
    <Suspense fallback={<FullPageLoader text={'Loading...'} />}>
      <Switch>
        <Route path={'/:lang'} component={SubRoutes} />
        <Redirect
          to={{
            pathname: `${
              props.appSettingsState?.htmlDirection === 'ltr' ? 'en' : 'ar'
            }${RouteKeys.Home}`,
          }}
          from={RouteKeys.Home}
        />
        <UnAuthenticateRoute
          // exact
          path={`/en${RouteKeys.PaymentLink}/ID/:id/configID/:configID/amount/:amount`}
          component={PaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.PaymentLinkSuccess}`}
          component={PaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          path={`/en${RouteKeys.PaymentLink}/ID/:id/customerId/:customerId/amount/:amount`}
          component={CustomerPaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.CustomerPaymentLinkSuccess}`}
          component={CustomerPaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.DiscountApproval}/token/:token`}
          component={DiscountApproval}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApprovalStatus}/:status`}
          component={ApprovalStatus}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.DiscountApproval}/token/:token`}
          component={DiscountApproval}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.ApprovalStatus}/:status`}
          component={ApprovalStatus}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          // exact
          path={`${RouteKeys.PaymentLink}/ID/:id/configID/:configID/amount/:amount`}
          component={PaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.PaymentLinkSuccess}`}
          component={PaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          path={`${RouteKeys.PaymentLink}/ID/:id/customerId/:customerId/amount/:amount`}
          component={CustomerPaymentLink}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.CustomerPaymentLinkSuccess}`}
          component={CustomerPaymentLinkSuccess}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveConfigurationRefund}/token/:token`}
          component={ApproveConfigurationRefund}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveConfigurationRefundStatus}/:status`}
          component={ApproveConfigurationRefundStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveCustomerRefund}/token/:token`}
          component={ApproveCustomerRefund}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveCustomerRefundStatus}/:status`}
          component={ApproveCustomerRefundStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveInvoiceCancel}/token/:token`}
          component={ApproveInvoiceCancel}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveInvoiceCancelStatus}/:status`}
          component={ApproveInvoiceCancelStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveOrderCancel}/token/:token`}
          component={ApproveOrderCancel}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveOrderCancelStatus}/:status`}
          component={ApproveOrderCancelStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveVin}/token/:token`}
          component={ApproveVin}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveVinStatus}/:status`}
          component={ApproveVinStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveTechConsultation}/token/:token`}
          component={ApproveTechConsultation}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveTechConsultationStatus}/:status`}
          component={ApproveTechConsultationStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveVinExtension}/token/:token`}
          component={ApproveVinExtension}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveVinExtensionStatus}/:status`}
          component={ApproveVinExtensionStatus}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.SpecialApproveBooking}/token/:token`}
          component={SpecialApproveBooking}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.SpecialApproveBookingStatus}/:status`}
          component={SpecialApproveBookingStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.LostLead}/token/:token`}
          component={LostLead}
          showFooter={false}
          avoidHeader
        />
        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.LostLeadStatus}/:status`}
          component={LostLeadStatus}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.ApproveConfigurationRefund}/token/:token`}
          component={ApproveConfigurationRefund}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`/en${RouteKeys.VerifyEmail}/token/:token`}
          component={VerifyEmail}
          showFooter={false}
          avoidHeader
        />

        <UnAuthenticateRoute
          exact
          path={`${RouteKeys.VerifyEmail}/token/:token`}
          component={VerifyEmail}
          showFooter={false}
          avoidHeader
        />

        <Route exact path={RouteKeys.NotFound} component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = (state: any) => ({
  appSettingsState: state.appSettingsState,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  // redirectSave: (to: string) => {
  //   dispatch(authUserActions.redirectSave(to));
  // },
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
